/* ==========================================================================
   stand-options.js
   --------------------------------------------------------------------------
   Behaviour for the metafield-driven mounting selector (snippets/mounting-options.liquid).
   Loaded from sections/template--product.liquid AFTER </wetheme-product-form>, so it
   runs outside the Vue inline-template (which strips <script> tags from its content).

   - select option -> active state, swap main image, update price/compare (combined),
     best-effort Affirm/Afterpay amounts
   - Add to cart (our own #StandAddToCart button) -> /cart/add.js (panel + maybe stand),
     then redirect to /cart

   Uses document-level delegation so it survives Vue re-rendering the form DOM.
   Debug: window.STAND_OPTIONS_DEBUG = true
   ========================================================================== */
(function () {
  'use strict';
  var DEBUG = !!window.STAND_OPTIONS_DEBUG;
  function log() { if (DEBUG) { try { console.log.apply(console, ['[stand-options]'].concat([].slice.call(arguments))); } catch (e) {} } }

  var originalImg = null;

  function findIn(scope, id) { return (scope && scope.querySelector('#' + id)) || document.getElementById(id); }

  function applyPricing(wrap, el) {
    var section = wrap.closest('.shopify-section') || document;
    var price = el.getAttribute('data-price');
    var compare = el.getAttribute('data-compare');
    var amtCents = el.getAttribute('data-amount-cents');
    var amtDollars = el.getAttribute('data-amount-dollars');

    var priceEl = findIn(section, 'ProductPrice');
    var compareEl = findIn(section, 'ComparePrice');

    if (priceEl) {
      var pm = priceEl.querySelector('.money') || priceEl;
      if (price) pm.textContent = price;
      if (priceEl.hasAttribute('content') && amtDollars) priceEl.setAttribute('content', amtDollars);
    } else { log('#ProductPrice not found'); }

    if (compareEl) {
      var cm = compareEl.querySelector('.money') || compareEl;
      if (compare) { cm.textContent = compare; compareEl.style.display = ''; compareEl.classList.add('on-sale'); }
      else { compareEl.style.display = 'none'; }
    }

    try { var a = document.querySelector('.affirm-as-low-as'); if (a && amtCents) { a.setAttribute('data-amount', amtCents); if (window.affirm && affirm.ui && affirm.ui.refresh) affirm.ui.refresh(); } } catch (e) {}
    try { var s = document.querySelector('square-placement, afterpay-placement'); if (s && amtDollars) s.setAttribute('data-amount', amtDollars); } catch (e) {}
    log('pricing', price, compare);
  }

  function swapImage(wrap, el) {
    var section = wrap.closest('.shopify-section') || document;
    var img = section.querySelector('.product-medias__primary img') ||
              section.querySelector('.product-medias__media--selected img') ||
              section.querySelector('.product-medias__media img');
    if (!img) { log('primary image not found'); return; }
    if (originalImg === null) originalImg = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };

    var url = el.getAttribute('data-image');
    try {
      var sw = section.querySelector('.swiper-container, .swiper');
      if (sw && sw.swiper && sw.swiper.slideTo) sw.swiper.slideTo(0);
      else { var b = section.querySelector('.swiper-pagination-bullet'); if (b) b.click(); }
    } catch (e) {}

    setTimeout(function () {
      var im = section.querySelector('.product-medias__primary img') || img;
      if (url) { im.setAttribute('srcset', ''); im.setAttribute('src', url); }
      else if (originalImg) { im.setAttribute('src', originalImg.src || ''); im.setAttribute('srcset', originalImg.srcset || ''); }
      log('image', url);
    }, 40);
  }

  function selectOption(el) {
    var wrap = el.closest('[data-mounting-options]'); if (!wrap) return;
    [].slice.call(wrap.querySelectorAll('.swatch-element')).forEach(function (x) { x.classList.toggle('active', x === el); });
    var input = el.querySelector('input'); if (input) input.checked = true;
    applyPricing(wrap, el);
    swapImage(wrap, el);
  }

  function qtyVal() {
    var q = document.getElementById('Quantity');
    var n = parseInt(q && q.value, 10);
    return (!n || n < 1) ? 1 : n;
  }

  function addToCart(btn) {
    var section = btn.closest('.shopify-section') || document;
    var wrap = section.querySelector('[data-mounting-options]') || document.querySelector('[data-mounting-options]');
    if (!wrap) { log('selector not found'); return; }

    var el = wrap.querySelector('.swatch-element.active') || wrap.querySelector('.swatch-element');
    var q = qtyVal();
    var panelId = wrap.getAttribute('data-panel-id');
    var panelName = wrap.getAttribute('data-panel-name') || '';
    var key = wrap.getAttribute('data-property-key') || 'Mounting Option';

    var addStand = !!(el && el.getAttribute('data-add-stand') === 'true' && el.getAttribute('data-stand-id'));
    var label = el ? el.getAttribute('data-label') : '';   // the chosen stand's label
    var bundleId = addStand ? ('maxg4-' + Date.now()) : null;

    // PANEL line -> shows the mounting option chosen for it
    var panelProps = {};
    if (el) panelProps[key] = label;                 // e.g. "Mounting Option": "Floor Stand for Max G4"
    if (bundleId) panelProps['_bundle_id'] = bundleId;

    var panel = { id: panelId, quantity: q, properties: panelProps };
    var items = [panel];

    // STAND line -> shows which panel it belongs to
    if (addStand) {
      var standProps = {};
      if (panelName) standProps['Panel'] = panelName; // e.g. "Panel": "Rouge Max G4 (Single)"
      standProps['_bundle_id'] = bundleId;
      items.push({ id: el.getAttribute('data-stand-id'), quantity: q, properties: standProps });
    }

    var btnLabel = btn.textContent;
    btn.setAttribute('disabled', 'disabled'); btn.classList.add('disabled');
    log('adding', items);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200 && res.description) throw new Error(res.description);
        window.location.href = '/cart';
      })
      .catch(function (err) {
        btn.removeAttribute('disabled'); btn.classList.remove('disabled'); btn.textContent = btnLabel;
        alert((err && err.message) || 'Sorry, this item could not be added to your cart.');
      });
  }

  /* delegated handlers — CAPTURE phase so Vue (bubble-phase / stopPropagation)
     can't swallow the click before we see it. Add button is checked first. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var add = e.target.closest('#StandAddToCart');
    if (add) { e.preventDefault(); e.stopImmediatePropagation(); addToCart(add); return; }

    var sw = e.target.closest('.swatch-element');
    if (sw && sw.closest('[data-mounting-options]')) { selectOption(sw); return; }
  }, true);

  function boot() {
    document.querySelectorAll('[data-mounting-options]').forEach(function (wrap) {
      log('init', wrap.getAttribute('data-panel-id'));
      // The default option already matches the server-rendered price + image,
      // so no initial overwrite is needed. Changes happen on click.
    });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();